import { useEffect, useState } from 'react'
import DashboardLayout from './layout'
import MyButton from '../components/buttons'
import { Link } from 'react-router-dom'
import {
  deleteMyWork,
  fetchWorkByUserId,
  updateLocalStorageWithUserWork,
} from '../../services/announcesWorks'
import { GoAlertFill } from 'react-icons/go'
import { useTranslation } from 'react-i18next'
import { fetchImages } from '../../services/gallery'
import GalleryRow from '../components/GalleryRow'
import { FaPen, FaTrash } from 'react-icons/fa'
import { getUser } from '../../services/oneUser'
import Modal from '../components/MyModal'
import VerificationSteps from '../components/VerificationSteps'
import { getUserProfile } from '../../services/profileService'
import CookieManager from '../lib/CookiesManager'

function AnnouncesPage() {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [announces, setAnnounces] = useState<any[]>([])
  const [images, setImages] = useState<any[]>([])
  const [hasPhone, setHasPhone] = useState(false)
  const [hasProfile, setHasProfile] = useState(false)
  const [userStatus, setUserStatus] = useState<string[]>([])
  const excludedStatus = [
    'maison privee',
    'bars et clubs prive',
    'salons de massage',
    'hotels coquins',
    'saunas prives',
    'clubs echangistes',
    'event',
  ]
  const excludedFields = [
    'id',
    'userId',
    'createdAt',
    'updatedAt',
    'disponibility',
    'escort',
    'status',
    'emailOnly',
    'practices',
    'timing',
    'price',
    'whatsapp',
    'callOnly',
    'phone',
    'website',
    'views',
    'location',
    'smsOnly',
    'isAvailable',
    'timingEscort',
    'priceEscort',
    'typeEscort',
    'availabilityStart',
    'email',
    'availabilityEnd',
  ]
  const translatableFields = ['location']
  const handleDeleteClick = () => {
    setIsDeleteModalOpen(true)
  }

  const handleDeleteConfirm = async () => {
    const token = CookieManager.getToken()
    const userId = CookieManager.getUserId()

    if (!token || !userId) {
      console.error('No token or userId found in local storage')
      return
    }

    try {
      const announceId = announces[0].id
      await deleteMyWork(announceId, token)
      setAnnounces([])
      localStorage.removeItem('myWork')
    } catch (error) {
      console.error('Error deleting work announce:', error)
    } finally {
      setIsDeleteModalOpen(false)
      window.location.reload()
    }
  }
  useEffect(() => {
    const checkUserProfile = async () => {
      const userId = CookieManager.getUserId()
      const token = CookieManager.getToken()

      if (userId && token) {
        try {
          const userData = await getUser(userId, token)
          const isEstablishment = userData.user.status.some((status: string) =>
            excludedStatus.includes(status),
          )
          setUserStatus(userData.user.status || [])
          setHasPhone(userData.user?.isPhoneConfirmed === true)

          if (isEstablishment) {
            setHasProfile(true)
          } else {
            const userProfile = await getUserProfile()
            setHasProfile(!!userProfile)
          }

          const userAnnounces: any = await fetchWorkByUserId(userId, token)
          if (Array.isArray(userAnnounces)) {
            setAnnounces(userAnnounces)
          } else if (userAnnounces && 'id' in userAnnounces) {
            setAnnounces([userAnnounces])
          } else {
            setAnnounces([])
          }

          await updateLocalStorageWithUserWork(userAnnounces)
          const userImages = await fetchImages(userId, token)
          setImages(userImages)
        } catch (error) {
          console.error('Error fetching user data or announces:', error)
        }
      }
      setLoading(false)
    }

    checkUserProfile()
  }, [])

  const isEstablishmentAccount = userStatus.some(status =>
    excludedStatus.includes(status),
  )

  if (loading) {
    return (
      <DashboardLayout title={t('my-job-offer')}>
        <div className='flex items-center justify-center mt-20 '>
          <div className='animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-redpink'></div>
        </div>
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout title={t('my-job-offer')}>
      <div className='px-0 mx-auto'>
        {!hasPhone ? (
          <VerificationSteps
            hasPhone={hasPhone}
            hasProfile={!isEstablishmentAccount ? false : undefined}
            t={t}
          />
        ) : (
          <div className='space-y-4'>
            <div className='flex items-center bg-anthracite text-white py-2 px-3 rounded-lg text-sm sm:text-base'>
              <GoAlertFill className='text-xl text-redpink mr-2 flex-shrink-0' />
              <span>{t('create-ad.announce-warning-work')}</span>
            </div>

            {announces.length > 0 ? (
              <div className='bg-grisclair p-3 sm:p-4 rounded-lg'>
                {announces.map(announce => (
                  <div key={announce.id} className='mb-6 last:mb-0'>
                    <div className='grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4'>
                      {Object.entries(announce)
                        .filter(
                          ([key, value]) =>
                            !excludedFields.includes(key) && value,
                        )
                        .map(([key, value]) => (
                          <div
                            key={key}
                            className={`${
                              key === 'title' || key === 'description'
                                ? 'col-span-full'
                                : ''
                            }`}
                          >
                            <div className='font-bold bg-grisclair2 p-2 rounded-lg text-sm sm:text-base mb-2'>
                              {t(`create-ad.${key}`)}
                            </div>
                            <div className='text-sm sm:text-base p-2'>
                              {typeof value === 'object' && value !== null
                                ? Object.entries(value)
                                    .map(([, subValue]) =>
                                      t(`provinces.${subValue}`),
                                    )
                                    .join(', ')
                                : translatableFields.includes(key)
                                ? t(`provinces.${value}`)
                                : (value as string)}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}

                {images.length > 0 && (
                  <div className='mt-4'>
                    <GalleryRow images={images} statusToShow={[3]} />
                  </div>
                )}

                <div className='flex flex-col sm:flex-row justify-center items-center gap-3 w-full mt-4'>
                  <Link
                    to='/dashboard/announce-work/'
                    className='w-full sm:w-auto'
                  >
                    <MyButton
                      variant='anthracite'
                      className='flex items-center justify-center w-full sm:w-auto'
                    >
                      <FaPen className='mr-2' />
                      <span>{t('modify-job-offer')}</span>
                    </MyButton>
                  </Link>

                  <MyButton
                    variant='redpink-anthracite'
                    onClick={handleDeleteClick}
                    className='flex items-center justify-center w-full sm:w-auto'
                  >
                    <FaTrash className='mr-2' />
                    <span>{t('create-ad.delete-job-offer')}</span>
                  </MyButton>
                </div>
              </div>
            ) : (
              <Link to='/dashboard/announce-work/' className='inline-block'>
                <MyButton variant='redpink-anthracite' className='py-3 px-6'>
                  {t('create-job-offer')}
                </MyButton>
              </Link>
            )}
          </div>
        )}

        <Modal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
        >
          <div className='bg-anthracite text-white p-4 sm:p-5 font-semibold text-lg sm:text-xl'>
            {t('create-ad.confirm-deletion')}
          </div>

          <div className='p-4 sm:p-6'>
            <GoAlertFill className='text-redpink text-3xl sm:text-4xl mx-auto mb-3' />
            <div
              className='mb-5 text-sm sm:text-base'
              dangerouslySetInnerHTML={{
                __html: t('create-ad.deletion-warning'),
              }}
            />

            <div className='flex flex-col sm:flex-row justify-end gap-3 sm:gap-4'>
              <MyButton
                variant='anthracite-redpink'
                onClick={() => setIsDeleteModalOpen(false)}
                className='w-full sm:w-auto'
              >
                {t('cancel')}
              </MyButton>
              <MyButton
                variant='redpink-anthracite'
                onClick={handleDeleteConfirm}
                className='w-full sm:w-auto'
              >
                {t('create-ad.delete-job-offer')}
              </MyButton>
            </div>
          </div>
        </Modal>
      </div>
    </DashboardLayout>
  )
}

export default AnnouncesPage
